// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'date',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'cost_price',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'price',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
